import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const DebugCardContainer = ({
  children,
  isAiGenerated,
  backgroundColor,
  borderColor
}) => {
  return /*#__PURE__*/_jsx(View, {
    padding: "400",
    marginBlock: "300",
    borderColor: borderColor,
    borderStyle: borderColor ? 'solid' : 'none',
    borderWidth: "100",
    backgroundColor: backgroundColor || (isAiGenerated ? 'fill-accent-magenta-subtle' : 'fill-tertiary-default'),
    borderRadius: "100",
    children: children
  });
};
export default DebugCardContainer;